import { render, staticRenderFns } from "./splitScreen.vue?vue&type=template&id=1e0e410a&scoped=true"
import script from "./splitScreen.vue?vue&type=script&lang=js"
export * from "./splitScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e410a",
  null
  
)

export default component.exports